var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('promotion-provider',{attrs:{"action-type":_vm.actionType},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var $promotionData = ref.$promotionData;
var $promotionMethods = ref.$promotionMethods;
return [_c('add-edit-promotion',{ref:"addEditPromotion",attrs:{"is-reloading":_vm.isReloading,"is-loading":$promotionData.isLoading,"promotion":$promotionData.promotion},on:{"reload-data":function($event){return _vm.reloadData($promotionMethods.reloadData)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }